import axios from 'axios'
import _get from 'lodash/get'

import { ERROR_MESSAGE_DELETING, ERROR_MESSAGE_SAVING } from '../constants'
import { handleRequestError } from './request'

export const CREATE_TAX_REGISTRATION_REASON = 'CREATE_TAX_REGISTRATION_REASON'
export const DELETE_TAX_REGISTRATION_REASON = 'DELETE_TAX_REGISTRATION_REASON'
export const RECEIVE_TAX_REGISTRATION_REASONS = 'RECEIVE_TAX_REGISTRATION_REASONS'
export const REMOVE_TAX_REGISTRATION_REASON = 'REMOVE_TAX_REGISTRATION_REASON'
export const REQUEST_TAX_REGISTRATION_REASONS = 'REQUEST_TAX_REGISTRATION_REASONS'
export const SAVE_TAX_REGISTRATION_REASON = 'SAVE_TAX_REGISTRATION_REASON'

export const requestTaxRegistrationReasons = () => (dispatch, getState) => {
    dispatch({ type: REQUEST_TAX_REGISTRATION_REASONS })

    const { profile } = getState()
    const { id: userId } = profile

    axios
        .get(`/taxregistration/${userId}/reasons`, { headers: { 'Cache-Control': 'no-cache' } })
        .then((response) => {
            const items = _get(response, ['data'], [])
            dispatch(receiveTaxRegistrationReasons({ items, fetchSuccessful: true }))
        })
        .catch((error) => {
            if (_get(error, ['response', 'status']) === 404) {
                dispatch(receiveTaxRegistrationReasons({ fetchSuccessful: true }))
                return
            }

            dispatch(receiveTaxRegistrationReasons({ fetchSuccessful: false }))
            dispatch(handleRequestError(error))
        })
}

export const receiveTaxRegistrationReasons = (data) => ({ type: RECEIVE_TAX_REGISTRATION_REASONS, data })

export const createTaxRegistrationReason = (data) => (dispatch, getState) => {
    dispatch({ type: CREATE_TAX_REGISTRATION_REASON, data })

    const { profile } = getState()
    const { id: userId } = profile

    return axios
        .post(`/taxregistrationreason`, { ...data, taxRegistrationId: userId })
        .then((response) => {
            const item = _get(response, ['data'], {})
            dispatch(receiveTaxRegistrationReasons({ items: [item] }))
        })
        .catch((error) => {
            dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_SAVING }))
            return Promise.reject(error)
        })
}

export const saveTaxRegistrationReason = (data) => (dispatch) => {
    dispatch({ type: SAVE_TAX_REGISTRATION_REASON, data })

    const { id } = data

    return axios
        .put(`/taxregistrationreason/${id}`, data)
        .then((response) => {
            const item = _get(response, ['data'], {})
            dispatch(receiveTaxRegistrationReasons({ items: [item] }))
        })
        .catch((error) => {
            dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_SAVING }))
            return Promise.reject(error)
        })
}

export const deleteTaxRegistrationReason = (id) => (dispatch) => {
    dispatch({ type: DELETE_TAX_REGISTRATION_REASON, data: { id } })

    return axios
        .delete(`/taxregistrationreason/${id}`)
        .then(() => {
            dispatch(removeTaxRegistrationReason(id))
        })
        .catch((error) => {
            dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_DELETING }))
            return Promise.reject(error)
        })
}

export const removeTaxRegistrationReason = (id) => ({ type: REMOVE_TAX_REGISTRATION_REASON, data: { id } })
